import { Tenant } from './../../../shared/constants/constant';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AuthorizationService } from './../../../core/services/auth/auth.service';

@Injectable()
export class HttpHeadersService {
    constructor(private authService: AuthorizationService) { }

    getQuoteLiteHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        };
    }

    getNewHireHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        };
    }

    getCensusLiteHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        };
    }

    getPlanLiteHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        };
    }

    getUserHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        };
    }

    getRateTableUAHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Content-Type': 'application/json',
                'userAgent': window.navigator.userAgent,
                Authorization: `Bearer ${this.authService.authToken}`
            })
        }
    }

    getNQSPlanAPIHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Tenant: Tenant.Name + '/' + Tenant.Id,
            }),
        }
    }

    getNQSQuoteAPIHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Tenant: Tenant.Name + '/' + Tenant.Id,
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Authorization: `Bearer ${this.authService.authToken}`,
            }),
        }
    }
}
